<!-- CP4380 -->

<main *ngIf="errorList.length" class="error-message-container" id="mainContainerId" > 
    <div id="genericErrorMessageID" [ngClass]="{'error-message-v2':true, 'error-message-multiple': show ,'error-message-v1':errorList.length <= 2}">
        <p class="error-message-content"  *ngFor="let error of errorList">
            <span> 
                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2120,24,24))" type="image/svg+xml" /> 
            </span>             
            <span class="error-message">* {{error}}</span>
        </p>
    </div>   
    <button *ngIf="errorList.length > 2" class = "error-expand" (click)="toggleShow()">     
        <span *ngIf="!show" ><img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,210,24,24))"
            style="margin:-17px 0px 0px 0px;
            object-fit: contain;" type="image/svg+xml" /></span>
        <span *ngIf="show"><img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,210,24,24))"
            style="margin:-17px 0px 0px 0px; transform: rotate(180deg); transition: 250ms;
            object-fit: contain;" type="image/svg+xml" /></span>
    </button>
</main>
